import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg custom-navbar sticky-top">
      <div className="container">

        {/* LOGO */}
        <Link className="navbar-brand logo p-3" to="/">
          NON TRADE  CEMENT
        </Link>

        {/* TOGGLER */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#menu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENU */}
        <div className="collapse navbar-collapse" id="menu">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

            <li className="nav-item">
              <NavLink className="nav-link" to="/">
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/about">
                About
              </NavLink>
            </li>

            {/* ✅ OUR PRODUCTS LINK */}
            <li className="nav-item">
              <NavLink className="nav-link" to="/our/product">
                Our Products
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/contact">
                Contact
              </NavLink>
            </li>

          </ul>

          {/* PHONE */}
         <a href="tel:02246301996" className="nav-phone"
         style={{ textDecoration: "none", color: "inherit" }}>
  📞 02246301996
</a>

        </div>
      </div>
    </nav>
  );
}
